<!--
 * @Author: zl
 * @Date: 2022-11-10 10:10:33
 * @LastEditTime: 2022-11-10 11:49:11
 * @LastEditors: zl
 * @Description: 标签管理 
-->
<template>
	<div class='tag-layout filter-layout'>
		<div class="filter-box">
			<el-tabs v-model="activeTab"
					 tab-position="top"
					 @tab-click="tabClick">
				<el-tab-pane name="0"
							 label="标签汇总"></el-tab-pane>
				<el-tab-pane name="1"
							 label="平台标签维护"></el-tab-pane>
			</el-tabs>
		</div>
		<div class="filter-content">
			<!-- 标签汇总 -->
			<template v-if="activeTab === '0'">
				<tagSummary></tagSummary>
			</template>

			<!-- 平台标签维护 -->
			<template v-if="activeTab === '1'">
				<tagMaintain></tagMaintain>
			</template>
		</div>
	</div>
</template>

<script>
import tagSummary from '@/views/system-management/tag/components/tag_summary'
import tagMaintain from '@/views/system-management/tag/components/tag_maintain'
export default {
	props: {},
	components: { tagSummary, tagMaintain },
	data() {
		return {
			activeTab: '0',
		}
	},
	created() {},
	mounted() {},
	methods: {
		/**
		 * @description: 准备工作
		 */

		// tabs 标签点击事件
		tabClick({ name }) {
			this.$router.push({
				path: '/tag-management',
			})
		},
	},
	computed: {},
}
</script>

<style lang='less' scoped>
.tag-layout {
	height: 100%;
	.filter-box {
		border-bottom: none;
	}
}
</style>